import { REDUCE_SINGLE_NOTE } from '../../constants/actions/policy';

export function reduceSingleNote(payload) {
    return {
        type: REDUCE_SINGLE_NOTE,
        payload,
    };
}
